import Router from "vue-router";
import Application from "@/views/Application.vue";
import Receipt from "@/views/Receipt.vue";

export const ROUTES = {
    APPLICATION: { path: "/", name: "Application" },
    RECEIPT: { path: "/kvittens", name: "Receipt" },
};

export default new Router({
    routes: [
        {
            path: ROUTES.APPLICATION.path,
            name: ROUTES.APPLICATION.name,
            component: Application,
        },
        {
            path: ROUTES.RECEIPT.path,
            name: ROUTES.RECEIPT.name,
            props: (route) => ({
                ...route.params,
                requested: route.params.requested === "true",
            }),
            component: Receipt,
        },
    ],
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
});
